let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("77Ui3")).then(() => parcelRequire('9veMp'));